module.exports = __webpack_public_path__ + "img/bgqycf_icon.a571b0a8.png";